//@flow
import React, { useState, useRef } from 'react';
import ReactPlayer from 'react-player';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { StringUtil } from 'utils/StringUtil';
import { Image } from 'components/atoms/image';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import playButton from 'assets/images/Play-Button-S.png';
import pauseButton from 'assets/images/pause.png';
import './style.scss';

type Props = {
  data: Object<dataProps>,
  type: string,
  openFor: string,
};

type dataProps = {
  id: number,
  page_title: string,
  cms_detail_page_contents: Array,
  media_path: string,
  thumbnail: string,
  mobile: string,
  web: string,
};

export const OurHomesMobileDescriptionOverlay = (props: Props) => {
  const { data } = props;
  const [isVideoPlaying, setVideoPlaying] = useState(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [videoPlayedPercentage, setVideoPlayedPercentage] = useState(0);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isSeeking, setIsSeeking] = useState(false);
  const player = useRef(ReactPlayer);
  const CurrentVideoStatus = data => {
    if (!isSeeking) {
      const remainingTime = !data
        ? 0
        : parseFloat((duration - data.playedSeconds) / 60).toFixed(2);
      setVideoPlayedPercentage(data.played);
      setRemainingSeconds(remainingTime);
    }
  };
  const handleSeekMouseDown = e => {
    setIsSeeking(true);
  };
  const handleSeekChange = e => {
    setVideoPlayedPercentage(parseFloat(e.target.value));
  };
  const handleSeekMouseUp = e => {
    player.current.seekTo(parseFloat(e.target.value));
    setIsSeeking(false);
  };
  const handleOnready = e => {
    setVideoPlaying(true);
    setIsVideoLoaded(true);
  };
  let section_one = [];
  let section_two = [];
  let section_three = [];
  let section_four = [];
  const media_path = `${data.media_path}${data.web}`;

  for (const extracted_data of data.cms_detail_page_contents) {
    if (extracted_data.section_name === 'section1') {
      section_one.push(extracted_data);
    } else if (extracted_data.section_name === 'section2') {
      section_two.push(extracted_data);
    } else if (extracted_data.section_name === 'section3') {
      section_three.push(extracted_data);
    } else if (extracted_data.section_name === 'section4') {
      section_four.push(extracted_data);
    }
  }
  let carousal_images;
  carousal_images = [
    section_four.length > 0 &&
      section_four[0].div_content &&
      `${media_path}/${section_four[0].div_content}`,
    section_four.length > 0 &&
      section_four[3].div_content &&
      `${media_path}/${section_four[3].div_content}`,
  ];

  const checkMediaType = (data, video_className, image_className) => {
    if (data.content_type === 'Video') {
      if (data && !data.video_thumbnail_url) {
        data.video_thumbnail_url = true;
      }
      return renderVideoContent(data, video_className);
    } else if (data.content_type === 'Image')
      return renderImageContent(data, image_className);
    else return null;
  };

  const renderVideoContent = (data, video_className) => {
    return (
      <>
        {data && (
          <>
            <div className="player-wrapper">
              <ReactPlayer
                ref={player}
                className="react-player"
                url={data.div_content}
                width="100%"
                height="100%"
                playing={isVideoPlaying}
                light={data.video_thumbnail_url}
                onProgress={CurrentVideoStatus}
                onReady={e => handleOnready(e)}
                loop={true}
                onDuration={e => setDuration(e)}
                config={{
                  vimeo: {
                    playerOptions: { playsinline: true },
                  },
                }}
              />
            </div>
            {isVideoLoaded && (
              <Row className="player-controls">
                <Col className="play-control" xs={{ span: 2 }} sm={{ span: 2 }}>
                  {isVideoPlaying && (
                    <img
                      className={'play-icon'}
                      src={pauseButton}
                      alt={'icon'}
                      style={{ width: '35px', height: '35px' }}
                      onClick={() => setVideoPlaying(!isVideoPlaying)}
                    />
                  )}
                  {!isVideoPlaying && (
                    <img
                      className={'play-icon'}
                      src={playButton}
                      alt={'icon'}
                      style={{ width: '35px', height: '35px' }}
                      onClick={() => setVideoPlaying(!isVideoPlaying)}
                    />
                  )}
                </Col>
                <Col className="seek-control" xs={{ span: 8 }} sm={{ span: 8 }}>
                  <input
                    type="range"
                    min={0}
                    max={0.999999}
                    step="any"
                    value={videoPlayedPercentage}
                    onMouseDown={handleSeekMouseDown}
                    onChange={handleSeekChange}
                    onMouseUp={handleSeekMouseUp}
                  />
                </Col>
                <Col className="time-control" xs={{ span: 2 }} sm={{ span: 2 }}>
                  <p>-{remainingSeconds}</p>
                </Col>
              </Row>
            )}
          </>
        )}
      </>
    );
  };

  const renderImageContent = (data, image_className) => {
    return (
      <Image
        className={image_className}
        src={`${media_path}/${data.div_content}`}
        alt="img"
        isHoveredImagePresent={true}
      />
    );
  };

  return (
    <div className={'Description-Mobile-overlay-body'}>
      <div className={'heading-section'}>
        <h1 className={'section-one-heading'}>
          {StringUtil.sliceHtml(section_one[0].div_content)}
        </h1>
        <h3 className={'section-one-tag-word'}>
          {StringUtil.sliceHtml(section_one[0].tag_word)}
        </h3>
      </div>
      <div className={'section-one-left-image'}>
        {section_one[2].div_name === 'Right1'
          ? renderImageContent(section_one[2], 'feature-img')
          : section_one[3].div_name === 'Right1'
          ? renderImageContent(section_one[3], 'feature-img')
          : null}
      </div>
      <p>{StringUtil.formatDescription(section_one[1].div_content, 200)}</p>
      {section_one[2] &&
      section_one[2].div_content &&
      section_one[2].div_name === 'Left3' ? (
        <div
          style={{ width: 'auto', marginLeft: '-22%', marginRight: '0%' }}
          className={'section-two-left-image'}
        >
          <Image
            className={'feature-img'}
            src={`${media_path}/${section_one[2].div_content}`}
            alt={'img'}
            isHoveredImagePresent={true}
          />
        </div>
      ) : null}
      <div className={'section-two-left-one'}>
        <div className={'vertical-bar'} />
        <h2 className={'section-two-heading'}>
          {StringUtil.sliceHtml(section_two[0].div_content)}
        </h2>
      </div>
      {section_two[1] && (
        <p className={'section-two-left-paragraph'}>
          {StringUtil.sliceHtml(section_two[1].div_content)}
        </p>
      )}
      {section_two[2] ? (
        <div className={'media-container'}>
          {checkMediaType(section_two[2], 'feature-video', 'feature-img')}
        </div>
      ) : null}

      {section_two[3] && Object.keys(section_two[3]).length > 0 ? (
        <div className={'section-two-right-content'}>
          {section_two[3].tag_word ? <h2>{section_two[3].tag_word}</h2> : null}
          {section_two[3].div_content ? (
            <p className={'section-two-left-paragraph'}>
              {StringUtil.sliceHtml(section_two[3].div_content)}
            </p>
          ) : null}
        </div>
      ) : null}
      {section_three.length > 0 && section_three[0].div_content ? (
        <div
          className={'section-three-left-image'}
          style={{
            width: 'auto',
            marginLeft:
              section_three[0].content_type === 'Image' ? '-22%' : 'inherit',
            marginTop: '0%',
          }}
        >
          {checkMediaType(section_three[0], 'feature-video', 'feature-img')}
        </div>
      ) : null}
      {section_four.length > 0 && section_four[1].div_content ? (
        <div className={'section-four-right-one'}>
          {section_four[1].tag_word ? (
            <h2>{section_four[1].tag_word}</h2>
          ) : null}
          <p className={'section-two-left-paragraph'}>
            {StringUtil.sliceHtml(section_four[1].div_content)}
          </p>
        </div>
      ) : null}
      {section_four.length > 0 && section_four[0] && section_four[3] ? (
        <div className={'carousal-images-container section-container'}>
          <HorizontalCarousel
            data={carousal_images}
            type={'our-difference-overlay-image'}
          />
        </div>
      ) : null}
      {section_four.length > 0 && section_four[2].div_content ? (
        <h2 className={'section-four-heading'}>
          {StringUtil.sliceHtml(section_four[2].div_content)}
        </h2>
      ) : null}
    </div>
  );
};
